// extracted by mini-css-extract-plugin
export default {"wrapper":"oO13V","title":"bn7uK","subtitle":"IG27b","button":"mc3UF"};